import { useCallback } from 'react'

import { IntercomLauncherClassName } from './use-set-up-intercom'

export const useLaunchIntercom = () => {
  const launchIntercom = useCallback(() => {
    // The menu item seems to swallow the event that Intercom is listening to, so I (Eric G) was unable to set the class name directly on that
    // Instead, firing the click on a temporary div with the class name
    // https://www.intercom.com/help/en/articles/2894-create-a-custom-launcher
    const div = document.createElement('div')
    div.className = IntercomLauncherClassName
    div.ariaHidden = 'true'
    document.body.appendChild(div)
    div.click()
    document.body.removeChild(div)
  }, [])
  return { launchIntercom }
}
